"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param element
 */

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

exports["default"] = getNodeName;